import {inputTypeList} from '../../IOTFYEDUTypeList'
import Button from './Components/Button'
import CheckBox from './Components/CheckBox'
import ImageStream from './Components/ImageStream'
import RadioButton from './Components/RadioButton'
import ReadSensor from './Components/ReadSensor'
import Start from './Components/Start'

// İlgili Devreye Ait Kontrollerin Eklenmesini Sağlıyoruz.
const ControlItem = ({
  circuitData,
  index1,
  index2,
  // experimentList,
  countButton,
  extraGraphics,
  deviceCode,
}: {
  circuitData: any
  // experimentList: any
  index1: number
  index2: number
  countButton: number
  extraGraphics: boolean
  deviceCode: number
}) => {
  let type = inputTypeList.filter((item: any) => item.id === circuitData.inputType)[0]?.name
  //  let deviceCodeData: any = experimentList.find((i: any) => i.id == circuitData.experimentId)

  if (circuitData.ioType === 1) {
    return type === 'RadioButton' ? (
      <RadioButton
        item={circuitData?.attiributeDTOs}
        index1={index1}
        index2={index2}
        title={circuitData?.name}
        //deviceCode={deviceCodeData?.deviceCode}
        deviceCode={deviceCode}
        experimentId={circuitData?.experimentId}
        circuitId={circuitData?.id}
      />
    ) : type === 'Checkbox' ? (
      <CheckBox
        item={circuitData?.attiributeDTOs}
        index1={index1}
        index2={index2}
        title={circuitData?.name}
        // deviceCode={deviceCodeData?.deviceCode}
        deviceCode={deviceCode}
        experimentId={circuitData?.experimentId}
        circuitId={circuitData?.id}
      />
    ) : type === 'Button' ? (
      <Button
        item={circuitData?.attiributeDTOs}
        index1={index1}
        index2={index2}
        title={circuitData?.name}
        // deviceCode={deviceCodeData?.deviceCode}
        deviceCode={deviceCode}
        countButton={countButton}
        experimentId={circuitData?.experimentId}
        circuitId={circuitData?.id}
      />
    ) : type === 'Start' ? (
      <Start
        item={circuitData?.attiributeDTOs}
        index1={index1}
        index2={index2}
        title={circuitData?.name}
        //deviceCode={deviceCodeData?.deviceCode}
        deviceCode={deviceCode}
        countButton={countButton}
        experimentId={circuitData?.experimentId}
        circuitId={circuitData?.id}
      />
    ) : null
  } else if (circuitData.ioType === 2) {
    return (
      <ReadSensor
        item={circuitData?.attiributeDTOs}
        title={circuitData?.name}
        //deviceCode={deviceCodeData?.deviceCode}
        deviceCode={deviceCode}
        chartIndex={circuitData.code}
        extraGraphics={extraGraphics}
        experimentId={circuitData?.experimentId}
        circuitId={circuitData?.id}
      />
    )
  }
  return (
    <ImageStream
      item={circuitData?.attiributeDTOs}
      index1={index1}
      index2={index2}
      title={circuitData?.name}
      //deviceCode={deviceCodeData?.deviceCode}
      deviceCode={deviceCode}
      experimentId={circuitData?.experimentId}
      circuitId={circuitData?.id}
    />
  )
}

export default ControlItem
